import { render, staticRenderFns } from "./StandardDateTimePicker.vue?vue&type=template&id=132cddd0&scoped=true&"
import script from "./StandardDateTimePicker.vue?vue&type=script&lang=ts&"
export * from "./StandardDateTimePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132cddd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
